// Slack users for recover alerts
export const SLACK_USERS = [
  { id: "U08S80SB5JA", name: "Jake" },
  { id: "U08EFLGJ15M", name: "Tony" },
  { id: "U073NUUPVC2", name: "Colby" }, // cspell:disable-line
] as const;

// Authorized username prefixes for marketing admin features.
// Matched against both @getredo.com and @redo.com domains.
export const ADMIN_MARKETING_AUTHORIZED_USERNAMES = [
  "dev",
  "matt.meyers",
  "jared",
  "logan.orr",
  "dan.ebeling",
  "jacob.cahoon",
  "josh",
  "zach",
  "stewart.thompson",
  "aradford",
  "jason.lowe",
  "austin",
  "aubree", // cspell:disable-line
  "meredith",
  "colby",
  "milo.atwood",
  "taylor.davis",
  "trenton",
  "henry",
  "zack.olsen",
  "kat",
  "corbin",
  "spencer.jorgensen",
  "sam.marberger",
  "chris",
  "seth.bennett",
  "michael.hammer",
  "michael.zinn",
  "tre.rossi",
  "michael.osborn",
  "henry.cho",
  "jake.inman",
  "breck", // cspell:disable-line
  "preston",
  "paul.maile", // cspell:disable-line
  "aaron.moise", // cspell:disable-line
];

// Contractor permissions - granular access control for recover contractors
export const ContractorPermission = {
  FLAGGED_TAB_ACCESS: "flagged_tab_access",
  SEND_EDITED_MESSAGES: "send_edited_messages",
  SEND_MANUAL_MESSAGES: "send_manual_messages",
  RETURNS_QUEUE_ACCESS: "returns_queue_access",
  DEDICATED_QUEUE_ACCESS: "dedicated_queue_access",
} as const;
export type ContractorPermission =
  (typeof ContractorPermission)[keyof typeof ContractorPermission];

// Map contractor emails to their permissions
export const AUTHORIZED_CONTRACTOR_PERMISSIONS: Record<
  string,
  ContractorPermission[]
> = {
  "jenevive@redo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "jenevive.son@getredo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "natalie.michell@getredo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "natalie.michell@redo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "hazelle.soriano@getredo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "debbie.recla@redo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "roselyne@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "christine.agustin@redo.com": [
    "flagged_tab_access",
    "send_edited_messages",
    "returns_queue_access",
  ],
  "shanae.earle@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "angel.adanza@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "lincoln.green@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "stephanie@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "jhulia@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "kenneth.andrade@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "pia.pacio@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "reyann@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "andrew.alcantara@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "melkatarah@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "evita.abul@redo.com": [
    "send_edited_messages",
    "send_manual_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "janine@redo.com": [
    "send_edited_messages",
    "send_manual_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "felicity@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "jocelyn.parcon@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "franq@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "joshua.sun@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "denice.adolfo@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "heidilyn@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "returns_queue_access",
  ],
  "john.merana@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "angelo.valentin@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "frances.acopio@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
  "joanna.marquez@redo.com": [
    "send_edited_messages",
    "flagged_tab_access",
    "send_manual_messages",
    "returns_queue_access",
  ],
};

// Check if a contractor has a specific permission
export function contractorHasPermission(
  email: string | undefined,
  permission: ContractorPermission,
): boolean {
  if (!email) {
    return false;
  }
  const permissions = AUTHORIZED_CONTRACTOR_PERMISSIONS[email.toLowerCase()];
  return permissions?.includes(permission) ?? false;
}

// Helper function to check if user is authorized for marketing admin features
export function isAdminMarketingUser(email: string | undefined): boolean {
  if (!email) {
    return false;
  }
  const lower = email.toLowerCase();
  return ADMIN_MARKETING_AUTHORIZED_USERNAMES.some(
    (username) =>
      lower === `${username}@getredo.com` || lower === `${username}@redo.com`,
  );
}
